/*!
 * Copyright (C) Design:Funedikly. All rights reserved.
 */

import * as React from 'react';

export const Github = () => {
  return (
    <svg viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
         fill="currentColor"
        d="M19.4419 0C8.69103 0 0 8.9375 0 19.9944C0 28.8328 5.56864 36.3143 13.2938 38.9622C14.2597 39.1613 14.6135 38.532 14.6135 38.0027C14.6135 37.5391 14.5816 35.9503 14.5816 34.2948C9.17336 35.4868 8.04713 31.9113 8.04713 31.9113C7.17799 29.5941 5.89019 28.9985 5.89019 28.9985C4.12007 27.7737 6.01913 27.7737 6.01913 27.7737C7.98266 27.9061 9.01298 29.8261 9.01298 29.8261C10.7509 32.8713 13.5513 32.0109 14.6779 31.4811C14.8387 30.1901 15.3541 29.2963 15.9013 28.7999C11.5878 28.3363 7.04945 26.6151 7.04945 18.9349C7.04945 16.7501 7.82149 14.9626 9.04482 13.5724C8.85181 13.076 8.17567 11.0232 9.23822 8.27572C9.23822 8.27572 10.8798 7.74597 14.5812 10.3281C16.1659 9.89043 17.8002 9.66778 19.4419 9.66591C21.0835 9.66591 22.7569 9.89787 24.3022 10.3281C28.004 7.74597 29.6456 8.27572 29.6456 8.27572C30.7081 11.0232 30.0316 13.076 29.8386 13.5724C31.0941 14.9626 31.8344 16.7501 31.8344 18.9349C31.8344 26.6151 27.296 28.303 22.9503 28.7999C23.6587 29.4287 24.2699 30.6203 24.2699 32.5073C24.2699 35.1886 24.2381 37.3405 24.2381 38.0023C24.2381 38.532 24.5923 39.1613 25.5577 38.9626C33.2829 36.3139 38.8516 28.8328 38.8516 19.9944C38.8834 8.9375 30.1605 0 19.4419 0Z"/>
    </svg>

  );
}
